<template>
  <div class="register-page">

    <div class="form-container pr">
      <div class="form-content">
        <div class="ipt-desc"><img src="@/assets/imgs/invitationPage/Frame 1321315129@2x.png"></div>
        <div class="ipt-box">
          <div class="form-item">
            <input placeholder="请输入手机号" v-model="data.phone" type="tel" maxlength="11">
          </div>
          <div class="form-item sms">
            <input placeholder="请输入验证码" v-model="data.code" type="tel" maxlength="4">
            <button @click="getSms" v-if="showCode">获取验证码</button>
            <button v-else>{{ counts }}s重新发送</button>
          </div>
          <div class="btn" @click="login">
            <img src="@/assets/imgs/invitationPage/Frame 1321315106@2x.png" />
          </div>

          <div class="protocol">
            <img @click="checked = false" v-if="checked" src="@/assets/imgs/invitationPage/checked4.png" alt="">
            <img v-else @click="checked = true" src="@/assets/imgs/invitationPage/unchecked4.png" alt="">
            <p>阅读并同意 <a @click="toProtocol">《法临注册协议》</a></p>
          </div>
        </div>
      </div>
      <!--  分割线      -->
<!--      <div class="dividing pa flex flex-space-between">-->
<!--        <img src="@/assets/imgs/invitationPage/line.png">-->
<!--        <img src="@/assets/imgs/invitationPage/line.png">-->
<!--      </div>-->
    </div>
    <div class="content-box pr">
<!--      <img class="title" src="@/assets/imgs/invitationPage/title4-lawsuitShare.png"/>-->
      <div class="content-box-con">
        <img src="@/assets/imgs/invitationPage/Frame 1321315181@2x.png"/>
      </div>
      <!--  分割线      -->
<!--      <div class="dividing pa flex flex-space-between">-->
<!--        <img src="@/assets/imgs/invitationPage/line.png">-->
<!--        <img src="@/assets/imgs/invitationPage/line.png">-->
<!--      </div>-->
    </div>
    <div class="content-box pr">
      <div class="content-box-con">
        <img src="@/assets/imgs/invitationPage/Frame 1321315177@2x.png"/>
      </div>
    </div>
    <div class="content-box pr">
      <div class="content-box-con">
        <img src="@/assets/imgs/invitationPage/Frame 1321315180@2x.png"/>
      </div>
    </div>
<!--    <div class="content-box pr">-->
<!--      <img class="title title-lawsuitShare" src="@/assets/imgs/invitationPage/title4-2.png"/>-->
<!--      <ul>-->
<!--        <li class="flex flex-align-center">-->
<!--          <img src="@/assets/imgs/invitationPage/Frame2478@2x.png"/>-->
<!--          <span> <i>权重评分系统更新</i>，免费获得本地曝光！</span>-->
<!--        </li>-->
<!--        <li class="flex flex-align-center">-->
<!--          <img src="@/assets/imgs/invitationPage/Frame1321315048@2x.png"/>-->
<!--          <span> 认证<i>免费得付费咨询</i>，分佣可提现！</span>-->
<!--        </li>-->
<!--        <li class="flex flex-align-center">-->
<!--          <img src="@/assets/imgs/invitationPage/Frame1321315049@2x.png"/>-->
<!--          <span> 你成案，我买单，抢案<i>成单立返￥899月卡</i>！</span>-->
<!--        </li>-->
<!--        <li class="flex flex-align-center">-->
<!--          <img src="@/assets/imgs/invitationPage/Frame1321315049@2x(lawsuitShare).png"/>-->
<!--          <span> ￥199线索包会员，全类型<i>案源任抢20次</i></span>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->

    <div class="fixed-btn" v-show="toPayState">
<!--      <van-popover-->
<!--          v-model="showPopover"-->
<!--          theme="dark"-->
<!--          placement="top"-->
<!--          get-container="fixed-btn"-->
<!--      >-->
<!--        <p class="popover-text fs13 tc">微信咨询客服，快捷认证</p>-->
<!--        <template #reference>-->
<!--          <div class="btn btn1" @click="toWeChatAppletBtn">-->
<!--            <img src="@/assets/imgs/invitationPage/wx4.png" class="icon" alt="" srcset="">-->
<!--            微信合作-->
<!--          </div>-->
<!--        </template>-->
<!--      </van-popover>-->
      <div class="btn btn2" @click="scrollToTop">
        <img src="@/assets/imgs/invitationPage/Frame 1321315106@2x.png" />
      </div>
    </div>
    <!-- 返回拦截弹窗 -->
    <van-popup
        v-model="weixinPopup"
        class="weixin-wrap"
        :close-on-click-overlay="false"
        round
    >
      <div class="content">
        <img src="@/assets/imgs/registerThree/close.png" alt="" class="close" @click="closeWeChatPopup">
        <p class="desc">全国10000+当事人咨询中</p>
        <p class="more"><span>添加客服微信</span>了解更多</p>
        <img src="@/assets/imgs/registerThree/cases.png" alt="" class="cases">
        <img src="@/assets/imgs/registerThree/btn.webp" alt="" class="btn" @click="toWeChatApplet">
      </div>
    </van-popup>
    <!-- 登录成功弹窗   -->
    <van-popup
        v-model="isLoginStatus"
        class="login-status-wrap tc"
        closeable
        :close-icon="close"
        @close="handleClose"
        round
    >
      <img src="@/assets/imgs/invitationPage/logo@2x.png" class="icon" alt="">
      <button @click="buttonDownload()" class="fs15">前往APP免费接单本地付费咨询</button>
      <p class="tip">系统将在<span>{{ countTips }}s</span>后跳转,若未跳转请手动<span>点击按钮跳转</span></p>
    </van-popup>
  </div>
</template>

<script>
import { sendCode} from "@a";
import {login} from "@a/activity";
import {lawyerChannelBuryPv} from "@a/invitation";
import {BEHAVIOR, BURY_POINT_TYPE, POINT_CODE} from "@/libs/config.js";
import {buriedChannelPoint} from "@a/common.js";
// import {Popover} from 'vant'
import close from '@/assets/imgs/invitationPage/x@2x.png'
import {wakeUpWeChatApplets} from "@/libs/tool.js";
import { awakeApp } from "@/libs/awake-app";


export default {
  name: "registerRegisterFour",
  data() {
    return {
      counts: 60,
      showCode: true,
      checked: true,
      timerInterval: '',
      data: {
        phone: '',
        code: ''
      },
      weixinPopup: false,//微信客服弹窗
      showPopover: true,
      isLoginStatus: false, //登陆成功
      countTips: 5,
      close,
      downloadUrls: {},
      toPayState: false
    }
  },
  components: {
    // 'van-popover': Popover
  },
  mounted() {
    let params = {
      code: 'LAWYER_ACTIVE_INDEX_PAGE',
      type: BURY_POINT_TYPE.PAGE,
      behavior: BEHAVIOR.VI,
      extra: { fromPosition: this.$route.query.fromPosition }
    };
    buriedChannelPoint(params);
    lawyerChannelBuryPv({
      channelId: this.$route.query.lawyerChannel
    })
    this.addListenerBack()
    setTimeout(() => {
      this.showPopover = false
    }, 2000)

    this.$nextTick(() => {
      window.addEventListener("scroll",this.throttle(this.handleScroll) );
    });

  },
  beforeDestroy() {
    window.removeEventListener("scroll",this.throttle(this.handleScroll));
  },
  methods: {
    // 跳转微信 客服页面
    wxURLScheme() {
      wakeUpWeChatApplets({
        // path:'pages/index/index',
        path: 'pages/toutiao-download/customer/index',
        query: 'code=CUSTOM_SERVICE_QR_CODE_COM'
      })
    },
    // 弹窗中去微信小程序
    toWeChatApplet() {
      let params = {
        code: POINT_CODE.LAW_GUIDE_SERVICE_WINDOW_CLICK,
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
      };
      buriedChannelPoint(params);
      this.wxURLScheme()
    },
    // 点击微信合作埋点
    toWeChatAppletBtn() {
      let params = {
        code: 'LAWYER_ACTIVE_PAGE_WE_CHAT_COOPERATE_CLICK',
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
      };
      buriedChannelPoint(params);
      this.wxURLScheme()
    },
    // 关闭弹窗
    closeWeChatPopup() {
      let params = {
        code: POINT_CODE.LAW_GUIDE_SERVICE_WINDOW_CLOSE_CLICK,
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
      };
      buriedChannelPoint(params);
      this.weixinPopup = false
    },
    // 底部获取案源埋点
    scrollToTop() {
      let params = {
        code: 'LAWYER_ACTIVE_BUTTON_PAGE_ACCEPT_INVITE_CLICK',
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
      };
      buriedChannelPoint(params);

      window.scrollTo({
        top: 60,
        left: 0,
        behavior: 'smooth'
      })
    },


    /* 添加返回监听*/
    addListenerBack() {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.backFn)
      this.$on('hook:destroyed', () => {
        window.removeEventListener('popstate', this.backFn)
      })
    },
    backFn() {
      // this.weixinPopup = true
      let params = {
        code: POINT_CODE.LAW_GUIDE_ADD_SERVICE_WINDOW,
        type: BURY_POINT_TYPE.PAGE,
        behavior: BEHAVIOR.VI,
      };
      buriedChannelPoint(params);

    },
    login() {
      let message = !this.data.phone && '请输入手机号！' ||
          !/^1\d{10}/.test(this.data.phone) && '输入手机号有误' ||
          !this.data.code && '请输入验证码！' ||
          !/\d{4}/.test(this.data.code) && '输入验证码有误' || null ||
          !this.checked && '请阅读并勾选《法临注册协议》' || null;
      if (message) return this.$toast(message);
      /**
       * inviteSource 3、律师端分享(inviteId) 2、营销人员分享(inviteSysUserId)
       */
      const inviteInfo = {
        inviteId: this.$route.query.inviteId || this.$route.query.inviteSysUserId,  //分享id
        inviteSource: this.$route.query.inviteId ? 5 : 2
      }
      let params = {
        code: 'LAWYER_ACTIVE_INDEX_PAGE_ACCEPT_INVITE_CLICK',
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
      };
      buriedChannelPoint(params);
      login({
        ...this.data,
        ...inviteInfo,
        lawyerChannel: this.$route.query.lawyerChannel
      }, {
        headers: {
          osVersion: 9
        }
      }).then(() => {
        this.isLoginStatus = true
        this.timerTips()
      }).catch(({data}) => {
        if (data.code === 1) {
          setTimeout(() => {
            this.isLoginStatus = true
            this.timerTips()
          }, 2000)
        }
      })
    },
    getSms() {
      let message = !this.data.phone && '请输入手机号！' ||
          !/^1\d{10}/.test(this.data.phone) && '输入手机号有误' || null
      if (message) return this.$toast(message)
      let params = {
        code: 'LAWYER_ACTIVE_PAGE_ACCOUNT_AUTH_CODE_CLICK',
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
        extra: {
          phone: this.data.phone
        }
      };
      buriedChannelPoint(params);
      sendCode({phone: this.data.phone},{
        headers:{
          osVersion:9
        }
      }).then(res => {
        if (!res.code) {
          this.$toast('发送成功')
          this.timer()
        }
      })
    },
    /* 倒计时*/
    timer() {
      if (!this.timerInterval) {
        this.counts = this.$options.data().counts
        this.showCode = false
        this.timerInterval = setInterval(() => {
          if (this.counts > 0) {
            this.counts--
          } else {
            this.clearTimer();
          }
        }, 1000)
      }
      this.$on('hook:destroyed', () => {
        this.clearTimer();
      })
    },
    clearTimer() {
      this.showCode = true
      clearInterval(this.timerInterval)
      this.timerInterval = null
    },
    /* 倒计时*/
    timerTips() {
      this.countTips = this.$options.data().countTips
      this.timerIntervalTips = setInterval(() => {
        if (this.countTips > 0) {
          this.countTips--
        } else {
          this.clearTimerTips();
          this.buttonDownload()
        }
      }, 1000)
      this.$on('hook:destroyed', () => {
        this.clearTimerTips();
      })
    },
    clearTimerTips() {
      clearInterval(this.timerIntervalTips)
    },
    /*按钮点击下载*/
    buttonDownload() {
      let params = {
        code: 'LAWYER_ACTIVE_PAGE_POP_WINDOW_GO_TO_APP_CLICK',
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
      };
      buriedChannelPoint(params);
      awakeApp();
    },
    /*打开协议*/
    toProtocol() {
      let params = {
        code: 'LAWYER_ACTIVE_PAGE_REGISTER_AGGREMENT_CLICK',
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
      };
      buriedChannelPoint(params);
      window.location.href = 'https://protocol.imlaw.cn/lawyer_user_protocol.html?header=0'
    },
    /*关闭弹窗的埋点*/
    handleClose(){
      let params = {
        code: 'LAWYER_ACTIVE_PAGE_POP_WINDOW_CLOSE_CLICK',
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
      };
      buriedChannelPoint(params);
    },
    //节流
    throttle(fn){
      let canRun = true;
      return function () {
        if (!canRun) return;
        canRun = false;
        setTimeout(() => {
          fn.apply(this, arguments);
          canRun = true;
        }, 500);
      };
    },
    handleScroll() {
      let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop; //滚动高度
      this.toPayState = scrollHeight > 500;
    },
  },
}
</script>

<style scoped lang="scss">
@keyframes scaleDraw {  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
  0%{
    transform: scale(1);  /*开始为原始大小*/
  }
  25%{
    transform: scale(1.1); /*放大1.1倍*/
  }
  50%{
    transform: scale(1);
  }
  75%{
    transform: scale(1.1);
  }
}
.register-page {
  min-height: 1402px;
  padding-bottom: 80px;
  background: #F2DFD8;

  .title {
    width: 154.29px;
    display: block;
    padding-top: 26px;
    margin: auto;

    &.title-1 {
      width: 271.29px !important;
    }
  }

  .content-box {
    //background: url("~@/assets/imgs/invitationPage/box4.png") no-repeat;
    background-size: 100%;
    width: 351px;
    //border-radius: 20px 20px 20px 20px;
    margin: 5px auto;
    //padding-bottom: 27px;

    .content-box-con {
      //margin: 10px 10px 0;
      margin-top: 12px;
      img {
        width: 100%;
        font-size: 0;
        display: block;
      }
    }

    ul {
      margin-top: 18px;

      li {
        width: 333px;
        height: 66px;
        background: #FFFFFF;
        border-radius: 14px 14px 14px 14px;
        font-size: 15px;
        margin: 8px auto 0;
        padding: 0 23px;
        box-sizing: border-box;
        font-weight: 400;

        i {
          color: #EB4738;
          font-style: normal;
        }

        img {
          width: 44px;
          height: 44px;
          margin-right: 12px;
        }
      }
    }
  }

  .dividing {
    bottom: -24px;
    z-index: 1;
    left: 36px;
    right: 36px;

    img {
      width: 10px;
      height: 44px;
    }
  }

  .register-header {
    padding-top: 73px;

    img {
      display: block;
      margin: 0 auto;
      width: 316px;
      height: 94px;
    }

    box-sizing: border-box;
    height: 357px;
  }

  .form-container {
    background: url("~@/assets/imgs/invitationPage/header4.png") no-repeat;
    background-size: 100%;
    padding-top: 400px;
    box-sizing: border-box;

    .form-content {
      box-sizing: border-box;
      width: 351px;
      padding: 18px 10px 20px;
      background: white;
      margin: 0 auto;
      border-radius: 10px;
      //background: url("~@/assets/imgs/invitationPage/box4.png") no-repeat;
      background-size: 100%;

      .ipt-desc {
        font-size: 14px;
        //background: #FFEBCD;
        border-radius: 10px 10px 0px 0px;
        //width: 351px;
        //height: 74px;
        margin: auto;
        color: #C37B0E;
        padding: 0px 12px 0;
        box-sizing: border-box;
        img{
          width: 100%;
        }
      }

      .ipt-box {
        background: #FFFFFF;
        border-radius: 10px 10px 10px 10px;
        margin-top: -10px;
        //padding: 12px 10px 0;
        //margin-bottom: 12px;
        padding-top: 12px;
      }

      .form-item {
        height: 45px;
        border: 1px solid #999999;
        border-radius: 22px;
        overflow: hidden;

        input {
          outline: none;
          text-indent: 27px;
          border: none;
          height: 100%;
          width: 100%;
          font-size: 15px;
          font-weight: 400;
        }
      }

      .sms {
        display: flex;
        margin-top: 12px;
        justify-content: space-between;
        align-items: center;
        padding-right: 9px;

        input {
          // width: auto;
          flex: 1;
        }

        button {
          width: 96px;
          border: none;
          font-weight: 400;
          background: none;
          outline: none;
          position: relative;
          background: #6255F2;
          border-radius: 24px 24px 24px 24px;
          height: 34px;
          font-size: 13px;
          color: #FFFFFF;
        }
      }

      .protocol {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 12px;

        img {
          width: 16px;
          height: 16px;
        }

        p {
          padding-left: 4px;
          font-size: 13px;
          font-weight: normal;
          color: #666666;

          a {
            color: #EB4738;
            text-decoration: underline;
          }
        }
      }

      .btn {
        display: flex;
        align-items: center;
        margin-top: 12px;
        justify-content: center;
        width: 324px;
        height: 45px;
        //background: linear-gradient(90deg, #FA700D 0%, #F34747 100%);
        border-radius: 22px;
        font-size: 17px;
        color: #FFFFFF;
        font-weight: 500;
        img{
          width: 95%;
          -webkit-animation-name: scaleDraw; /*关键帧名称*/
          -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
          -webkit-animation-iteration-count: infinite;  /*动画播放的次数*/
          -webkit-animation-duration: 3s;
        }
      }
    }
  }

  .pictures {
    img {
      display: block;
      width: 100%;
    }
  }

  .fixed-btn {
    width: 375px;
    height: 70px;
    background: #FFFFFF;
    box-shadow: 0px -3px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 16px 16px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 17px 10px 17px;
    position: fixed;
    bottom: 0;
    box-sizing: border-box;
    z-index: 9;

    ::v-deep {
      .van-popover__content {
        background-color: transparent;
      }
    }

    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 44px;
      border-radius: 68px 68px 68px 68px;
      //width: 165px;

      .icon {
        margin-right: 4px;
        width: 25px;
        height: 25px;
        vertical-align: middle;
      }
    }

    .btn1 {
      background: #22BF7E;
      color: #FFFFFF;
      font-size: 15px;
      position: relative;

      .openweapp {
        width: 100%;
        height: 100%;
        background: transparent;
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    .btn2 {
      //background: linear-gradient(90deg, #FA700D 0%, #F34747 100%);
      color: #fff;
      font-size: 17px;
      padding-top: 8px;
      img{
        width: 95%;
        -webkit-animation-name: scaleDraw; /*关键帧名称*/
        -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
        -webkit-animation-iteration-count: infinite;  /*动画播放的次数*/
        -webkit-animation-duration: 3s;
      }
    }
  }

  .weixin-wrap {
    width: 324px;
    height: 401px;

    .content {
      width: 324px;
      height: 401px;
      background: url('~@/assets/imgs/registerThree/bg@2x.png') no-repeat;
      background-size: 100% 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 42px;
      box-sizing: border-box;

      .close {
        position: absolute;
        width: 25px;
        height: 25px;
        top: 14px;
        right: 14px;
      }

      .desc {
        font-size: 14px;
        color: #999999;
        margin-bottom: 4px;
      }

      .more {
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000;

        span {
          color: #F24A47;
        }
      }

      .cases {
        width: 264px;
        height: 194px;
        margin: 17px 0 25px 0;
      }

      .btn {
        width: 264px;
        height: 59px;
      }
    }
  }
}

.popover-text {
  width: 175px;
  height: 38px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 8px 8px 8px 8px;
  line-height: 38px;
}

.login-status-wrap {
  width: 311px;
  height: 255px;
  background: #FFFFFF;
  border-radius: 16px 16px 16px 16px;

  img {
    width: 171px;
    height: 48px;
    margin-top: 56px;
    margin-bottom: 39px;
  }

  button {
    width: 241px;
    height: 48px;
    background: linear-gradient(90deg, #FA700D 0%, #F34747 100%);
    border-radius: 65px 65px 65px 65px;
    color: #FFFFFF;
    border: none;
    margin-bottom: 16px;
  }

  p {
    font-size: 12px;
    color: #666666;

    span {
      color: #EB4738;
    }

  }
}
</style>
